import { MutableRefObject, useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useRouter } from 'next/router';

import EFVideo from '@/components/UI/EFVideo';
import { useLang } from '@/i18n';

import NextImage from '@/components/NextImage';
import KolSection from '../KolSection';

const kolLocaleArr = ['us', 'ca', 'uk', 'eu'];

export default function Robots() {
    const { t } = useLang('bladeroboticlawnmower');
    const videoRef = useRef<MutableRefObject<any>>(null);
    const { locale } = useRouter();
    const videoRobotsRef = useRef<MutableRefObject<any>>(null);
    const [sources1, setSources1] = useState<string[] | null>(null);
    const [sources2, setSources2] = useState<string[] | null>(null);

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.robot-ani-01', { opacity: 0 }, { opacity: 1 }, 1],
                ['.robot-ani-02', { scale: 0.5 }, { scale: 1 }, 2.5],
                ['.robot-ani-03', { opacity: 0, y: 80 }, { opacity: 1, y: 0 }, 0.6],
                ['.robot-ani-03', { opacity: 1 }, { opacity: 0 }, 1],
                ['.robot-ani-02', { opacity: 1 }, { opacity: 0.3 }, 1],
            ],
            asyncTimeLine: [0, 0, 2.8, 4.2, 3.8],
            triggerElement: '.robots-sec-01',
            triggerHook: 1,
            offset: '10%',
            duration: '190%',
        });

        const videoRobots: any = videoRobotsRef.current;
        AniContainer.create({
            triggerElement: '.robots-sec-01',
            triggerHook: 1,
            offset: 200,
            duration: 0,
            onEnter: () => {
                videoRobots?.play();
            },
            onLeave: () => {
                videoRobots?.setCurrentTime(0);
                videoRobots?.pause();
            },
            isGpu: false,
            onLazyLoad: async () => {
                setSources1(['/video/blade/detail/pc/robot_01.webm', '/video/blade/detail/pc/robot_01.mp4']);
            },
        });

        AniContainer.create({
            asyncFromTo: [
                ['.robot-ani-04', { opacity: 0 }, { opacity: 1 }, 0.6],
                // ['.robot-ani-05', { opacity: 1, scale: 2.3 }, { opacity: 1, scale: 2.3 }, 1],
                ['.robot-ani-04', { opacity: 1, y: 0 }, { opacity: 0, y: -150 }, 1],
                ['.robot-ani-05', { scale: 2.3 }, { scale: 1 }, 1],
                ['.robot-ani-06', { opacity: 0, y: 290 }, { opacity: 1, y: 0 }, 1],
            ],
            // asyncTimeLine: [0, 1.8, 1.8, 3, 3.3],
            asyncTimeLine: [0, 3, 3, 3.3],
            triggerElement: '.robots-sec-02',
            triggerHook: 0.4,
            offset: 0,
            duration: '160%',
        });

        const video: any = videoRef.current;
        AniContainer.create({
            triggerElement: '.robots-sec-02',
            triggerHook: 0.9,
            offset: 0,
            duration: 0,
            onEnter: () => {
                video?.play();
            },
            onLeave: () => {
                video?.setCurrentTime(0);
                video?.pause();
            },
            isGpu: false,
            onLazyLoad: async () => {
                setSources2(['/video/blade/detail/pc/robot_02.webm', '/video/blade/detail/pc/robot_02.mp4']);
            },
        });
    }, []);

    return (
        <div className={css['mod-robots']}>
            <div className="robots-sec-01">
                <div className="sticky-box">
                    <div className="robots-01 box-center">
                        <div className="robot-ani-01">
                            <div className="video-box robot-ani-02">
                                <EFVideo ref={videoRobotsRef} autoPlay={false} sources={sources1} className="video" />
                            </div>
                        </div>
                    </div>
                    <div className="box-center">
                        <div className="robots-02 robot-ani-03">
                            <div className="robots-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/ces_2023.webp')}
                                    src={require('@publicLocal/ces_2023.png')}
                                    alt={t('detail.robots_title')}
                                    aria-label={t('detail.robots_title')}
                                />
                            </div>
                            <p className="robots-01-title">
                                <span>{t('detail.robots_title')}</span>
                            </p>
                            <p className="robots-01-desc">{t('detail.robots_desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
            {!!kolLocaleArr.includes(locale) && <KolSection />}
            <div className="robots-sec-02">
                <div id="robots" className="point"></div>
                <div className="sticky-box">
                    <div className="robots-01 box-center">
                        <div className="box-center">
                            <div className="robots-03">
                                <div className="robot-ani-06">
                                    <p className="robots-03-title">{t('detail.robots_sec3_title')}</p>
                                    <p className="robots-03-desc">{t('detail.robots_sec3_desc')}</p>
                                </div>
                            </div>
                            <div className="video-box robot-ani-05">
                                <EFVideo ref={videoRef} autoPlay={false} className="video" sources={sources2} />
                            </div>
                        </div>
                    </div>
                    <div className="box-center">
                        <div className="robots-02 robot-ani-04">
                            <p className="robots-01-title robots-02-title">{t('detail.robots_sec2_title')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
